<script>
  import moment from 'moment'

  export default {
    components: {},
    nome: 'resultado-importacao-secundaria-leilao',
    props: {
      relatorio: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        data: {
          totalEnviados: 0,
          mensagens: []
        },
        isLoaded: false,
        semResultado: false
      }
    },
    computed: {
      total () {
        return this.relatorio.totalEnviados
      },
      totalAtualizadosSucesso () {
        return (this.total - this.relatorio.mensagens.length)
      },
      porcentagemEfetividade () {
        const valor = this.calculaPorcentagem(this.totalAtualizadosSucesso, this.total)
        return {
          valor,
          class: parseInt(valor) === 100 ? 'text-success' : 'text-danger'
        }
      }
    },
    filters: {
      formatarData (date) {
        return moment(date).format('DD/MM/YYYY LTS')
      }
    },
    mounted () {
      this.isLoaded = true
    },
    methods: {
      calculaPorcentagem (valor, total) {
        if (total < 1) return 0
        return ((valor / total) * 100).toFixed(2)
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-12"><h1 class="m-n font-thin h3">Resultado da Importação Secundária</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel">
          <div class="panel-body">
            <div class="resultado-estatísticas-geracao m-b-lg" v-if="!semResultado">
              <div>Total de Lotes Enviados: <span>{{total}}</span></div>
              <div>Sucesso: <span>{{totalAtualizadosSucesso}}</span></div>
              <div>Falhas: <span>{{relatorio.mensagens.length}}</span></div>
              <div>Efetividade: <span :class="porcentagemEfetividade.class">{{porcentagemEfetividade.valor}}%</span></div>
            </div>
            <div>
              <div class="text-dark resultado-success m-t-xl" v-if="semResultado">
                <i class="fa fa-warning fa-5x"></i>
                <span>Não foi feita importação secundária para este leilão!</span>
              </div>
              <div class="text-success resultado-success m-t-xl" v-else-if="parseInt(porcentagemEfetividade.valor) === 100">
                <i class="fa fa-check-circle fa-5x"></i>
                <span>Todos os lotes foram atualizados!</span>
              </div>
              <table class="table-lotes-leilao table table-clicked table-striped bg-whit b-a" v-else>
                <thead>
                <tr>
                  <th class="text-nowrap">Mensagens de Erro</th>
                </tr>
                </thead>
                <tbody>
                <tr class="leilao-list-lote-item" v-for="item in relatorio.mensagens">
                  <td>{{item}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .resultado-estatísticas-geracao {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .resultado-estatísticas-geracao span {
    font-weight: bold;
  }
  .resultado-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
</style>



// WEBPACK FOOTER //
// ResultadoImportacaoSecundariaLeilao.vue?73b3cf0b